import { render, staticRenderFns } from "./BaseDynamicForm.vue?vue&type=template&id=08e2173e"
import script from "./BaseDynamicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseDynamicForm.vue?vue&type=script&setup=true&lang=js"
import style0 from "./BaseDynamicForm.vue?vue&type=style&index=0&id=08e2173e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports